import store from '@/store'

const summarizedFlow = store.getters['auth/pharmaceuticalDomainConfig'].SUMMARIZEDFLOW

export const FAMILY_HISTORY_FAMILY_OPTIONS = [
  { key: 'avos', name: 'Avós' },
  { key: 'filhos', name: 'Filhos' },
  { key: 'irmaos', name: 'Irmãos' },
  { key: 'netos', name: 'Netos' },
  { key: 'pais', name: 'Pais' },
  { key: 'primos', name: 'Primos' },
  { key: 'sobrinhos', name: 'Sobrinhos' },
  { key: 'tios', name: 'Tios' },
]

export const FAMILY_HISTORY_PROFILE_OPTIONS = [
  {
    key: 'doenca_reumatologia',
    name: 'Alguém na família tem doença reumatológica (reumatismo, artrite, doença auto-imune)?',
    complementText: 'Informe o nome da doença',
    askForTreatment: true,
    degrees: ['1º', '2º', '3º'],
  },
  {
    key: 'esclerose_multipla',
    name: 'Alguém na família tem esclerose mútlipla?',
    degrees: ['1º', '2º', '3º'],
    required: summarizedFlow,
  },
  {
    key: 'cancer_familia',
    name: 'Algum histórico de câncer na família?',
    complementText: 'Informe o tipo de câncer',
    degrees: ['1º', '2º', '3º'],
  },
]

export const FAMILY_ATOPIA_OPTIONS = [
  {
    key: 'asma',
    name: 'Asma',
    degrees: ['1º', '2º', '3º'],
    required: summarizedFlow,
  },
  {
    key: 'rinite_alergica',
    name: 'Rinite Alérgica',
    degrees: ['1º', '2º', '3º'],
    required: summarizedFlow,
  },
  {
    key: 'dermatite_atopica',
    name: 'Dermatite Atópica',
    degrees: ['1º', '2º', '3º'],
    required: summarizedFlow,
  },
  {
    key: 'psoriase',
    name: 'Psoríase',
    degrees: ['1º', '2º', '3º'],
    required: summarizedFlow,
  },
  {
    key: 'urticaria',
    name: 'Urticária',
    degrees: ['1º', '2º', '3º'],
  },
  {
    key: 'angioedema',
    name: 'Angioedema',
    degrees: ['1º', '2º', '3º'],
  },
]

const DA_SUMMARIZED_KEYS = ['asma', 'rinite_alergica', 'dermatite_atopica']

export const FAMILY_ATOPIA_SUMMARIZED_OPTIONS_DA = FAMILY_ATOPIA_OPTIONS.filter((option) =>
  DA_SUMMARIZED_KEYS.includes(option.key),
)

const PSORIASIS_SUMMARIZED_KEYS = ['esclerose_multipla', 'psoriase']

export const FAMILY_HISTORY_SUMMARIZED_OPTIONS_PSORIASIS = FAMILY_HISTORY_PROFILE_OPTIONS.filter((option) =>
  PSORIASIS_SUMMARIZED_KEYS.includes(option.key),
)

export const FAMILY_ATOPIA_SUMMARIZED_OPTIONS_PSORIASIS = FAMILY_ATOPIA_OPTIONS.filter((option) =>
  PSORIASIS_SUMMARIZED_KEYS.includes(option.key),
)
